export enum Navigation {
  DefaultRoute = "schedules",
}
